import React, { useMemo } from 'react';
import { Card } from '@mui/material';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { getDeliveryDetail, getRegistrationDetail } from '../../services/registration';

import Tabs from '../../components/Tabs';
import useMetaData from '../../hooks/useMetaData';
import QuickGlance from './QuickGlance';
import Team from './Team';
import Vehicle from './Vehicle';
import Customer from './Customer';
import Payment from './Payment';
import Insurance from './Insurance';
import Order from './Order';
import CategoryComponent from './CategoryComponent';

import { ReactComponent as CustomerIcon } from '../../assets/icons/customer.svg';
import { ReactComponent as DeliveryIcon } from '../../assets/icons/delivery.svg';
import { ReactComponent as DocumentsIcon } from '../../assets/icons/documents.svg';
import { ReactComponent as InsuranceIcon } from '../../assets/icons/insurance.svg';
import { ReactComponent as OrderIcon } from '../../assets/icons/order.svg';
import { ReactComponent as PaymentIcon } from '../../assets/icons/payment.svg';
import { ReactComponent as RegistrationIcon } from '../../assets/icons/registration.svg';
import { ReactComponent as TeamIcon } from '../../assets/icons/team.svg';
import { ReactComponent as VehicleIcon } from '../../assets/icons/vehicle.svg';
import { ReactComponent as QuickGlanceIcon } from '../../assets/icons/star.svg';

const Icons = {
  'Quick Glance': <QuickGlanceIcon />,
  Vehicle: <VehicleIcon />,
  Customer: <CustomerIcon />,
  Payment: <PaymentIcon />,
  Documents: <DocumentsIcon />,
  Insurance: <InsuranceIcon />,
  Delivery: <DeliveryIcon />,
  Order: <OrderIcon />,
  Registration: <RegistrationIcon />,
  Team: <TeamIcon />,
};

const VehicleVerticalTabs = () => {
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.vehicleDetailsTabs);

  const TabContents = useMemo(
    () => ({
      'Quick Glance': <QuickGlance />,
      Team: <Team />,
      Vehicle: <Vehicle />,
      Customer: <Customer />,
      Payment: <Payment />,
      Registration: (
        <CategoryComponent
          module={META_DATA_MODULES.v360Page}
          subModule={META_DATA_SUB_MODULES.registrationTab}
          getDataMethod={getRegistrationDetail}
        />
      ),
      Insurance: <Insurance />,
      Documents: (
        <CategoryComponent
          module={META_DATA_MODULES.v360Page}
          subModule={META_DATA_SUB_MODULES.documentTab}
          getDataMethod={getRegistrationDetail}
        />
      ),
      Delivery: (
        <CategoryComponent
          module={META_DATA_MODULES.v360Page}
          subModule={META_DATA_SUB_MODULES.deliveryTab}
          getDataMethod={getDeliveryDetail}
        />
      ),
      Order: <Order />,
    }),
    []
  );

  const tabItems = useMemo(
    () =>
      metaData?.tabs?.map((tab: any) => ({
        label: tab.propertyName,
        icon: Icons[tab.icon as keyof typeof Icons],
        content: TabContents[tab.component as keyof typeof TabContents],
      })) || [],
    [TabContents, metaData?.tabs]
  );

  return (
    <Card sx={{ p: 1, minHeight: 900 }}>
      <Tabs tabItems={tabItems} orientation="vertical" />
    </Card>
  );
};

export default VehicleVerticalTabs;
